(function($) {

    function slider() {
        if ($('.js_featured_carousel_hooverdc, .fellow-slider').length > 0) {
            setTimeout(function() {
                $(".fellow-slider").css({ "opacity": "1" });
            }, 500);
            $('.fellow-slider .slider-wrapper').not('.slick-initialized').slick({
                infinite: false,
                slidesToShow: 2,
                slideToScroll: 1,
                responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    },

                ]

            });
        }
    }

    $(document).ready(function() {
        slider();
        // if ($('.article-detail.news-detail .content .fellow-card').length > 0) {
        //     $(".article-detail.news-detail .content .fellow-card .hover-content .detail-content p").html($(".article-detail.news-detail .content .fellow-card .hover-content .detail-content p").html().replace("&amp;", "&"));
        //     $(".article-detail.news-detail .content .fellow-card .hover-content .detail-content p").html($(".article-detail.news-detail .content .fellow-card .hover-content .detail-content p").html().replace("amp;", ""));
        // }
    });
    $(window).on("load", function() {
        slider();
    });
})(jQuery);